import React, { useEffect } from 'react'
import CircularProgress from "@mui/material/CircularProgress";
import useFetch from '../hooks/use-fetch.hook'
import { api_constants } from '../constants/api.constants'
import { Term } from '../model/term.model'
import ErrorIcon from '@mui/icons-material/Error';

const TOSPage = () => {
	const { data, isLoading, error, refetch } = useFetch<Array<Term>>({
		endpoint: api_constants.urls.tos,
		method: "GET",
	})

	useEffect(()=> {
		refetch()
	}, [])

	const Terms = (): JSX.Element => {
		if(!data) { return <></> }

		return (
			<div style={{padding: 30}}>
				<h1>Terms and Conditions</h1>
				{
					data.map((item: Term)=> {
						return (
							<div key={item.name}>
								<h3 style={{color: "black"}}>{item.name}</h3>
								{
									item.items.map((subSection)=>{
										return (
											<p style={{color: "grey"}} key={subSection}>{subSection}</p>
										)
									})
								}
							</div>
						)
					})
				}
			</div>
		)
	}
	
	const Loading = () => {
		return (
			<div style={{display: "flex", height: "100vh", justifyContent: "center", alignItems: "center", flexDirection: "column"}}>
				<CircularProgress style={{color: "grey"}} />
				<p style={{color: "grey"}}>Loading...</p>
			</div>
		)
	}

	const Error = () => {
		const color = "#FF6347"
		const messages = Array.isArray(error?.message) ? error?.message : [];
		const Message = ({message}:{message:string}) => (
			<div style={{display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column"}}>
				<p style={{color: color}} key={message}>{message}</p>
				<p style={{color: color}}>Tap to retry</p>
			</div>
		)

		const handleClick = async() => {
			await refetch()
		}

		return (
			<div onClick={handleClick} style={{cursor: 'pointer', display: "flex", height: "100vh", justifyContent: "center", alignItems: "center", flexDirection: "column"}}>
				<ErrorIcon style={{color: color, fontSize: 100}} />
				{
					Array.isArray(error?.message) ? (
						(messages ?? []).map((message)=>{
							return (
								<Message message={message} />
							)
						})
					) : (
						<Message message={error?.message ?? "Something went wrong"} />
					)
				}
			</div>
		)
	}

	if(isLoading) {
		return (
			<Loading />
		)
	} else if(error) {
		return (
			<Error />
		)
	} else if(data) {
		return (
			<Terms />
		)
	}  else {
		return (
			<Error />
		)
	}
}

export default TOSPage